import { type FC } from "react";

import { Clock, DollarSign, Landmark } from "lucide-react";

import { Card, CardContent } from "@/shared/components/ui/card";

interface KeyDetailsCardProps {
  county: string | null;
  timeline: string;
  filingFee: string;
  attorneyStatus: string;
}

export const KeyDetailsCard: FC<KeyDetailsCardProps> = ({
  county,
  timeline,
  filingFee,
  attorneyStatus,
}) => (
  <Card className="bg-white">
    <CardContent className="pt-6 flex flex-col gap-5">
      <h3 className="font-semibold">Key details</h3>
      <div className="flex flex-col divide-y divide-primary">
        <div className="flex flex-col gap-1 pb-4">
          <div className="flex items-center gap-2">
            <Landmark className="h-4 w-4 text-secondary" />
            <span className="text-sm text-secondary">Courthouse</span>
          </div>
          <span className="text-sm font-medium">
            Surrogate's Court{county ? `, ${county} County` : ""}
          </span>
        </div>
        <div className="flex flex-col gap-1 py-4">
          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-secondary" />
            <span className="text-sm text-secondary">Timeline</span>
          </div>
          <span className="text-sm font-medium">{timeline}</span>
        </div>
        <div className="flex flex-col gap-1 py-4">
          <div className="flex items-center gap-2">
            <DollarSign className="h-4 w-4 text-secondary" />
            <span className="text-sm text-secondary">Filing fee</span>
          </div>
          <span className="text-sm font-medium">{filingFee}</span>
        </div>
        <div className="flex flex-col gap-1 pt-4">
          <div className="flex items-center gap-2">
            <Landmark className="h-4 w-4 text-secondary" />
            <span className="text-sm text-secondary">Attorney status</span>
          </div>
          <span className="text-sm font-medium">{attorneyStatus}</span>
        </div>
      </div>
    </CardContent>
  </Card>
);
